import { render, staticRenderFns } from "./RegistrationAndLoginSupportSuccess.vue?vue&type=template&id=58378f0e&scoped=true&"
var script = {}
import style0 from "./RegistrationAndLoginSupportSuccess.vue?vue&type=style&index=0&id=58378f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58378f0e",
  null
  
)

export default component.exports